module.exports = __webpack_public_path__ + "assets/ic_tree15.bb8d513e.svg";